import styled from 'styled-components';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacing.xl};
`;

const Section = styled.section`
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

const Title = styled.h1`
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: ${({ theme }) => theme.spacing.lg};
`;

const Subtitle = styled.h2`
  color: ${({ theme }) => theme.colors.primary};
  margin: ${({ theme }) => `${theme.spacing.lg} 0`};
  font-size: 1.5rem;
`;

const Text = styled.p`
  margin-bottom: ${({ theme }) => theme.spacing.md};
  line-height: 1.6;
`;

const List = styled.ul`
  margin: ${({ theme }) => theme.spacing.md} 0;
  padding-left: ${({ theme }) => theme.spacing.xl};

  li {
    margin-bottom: ${({ theme }) => theme.spacing.sm};
    line-height: 1.6;
  }
`;

const Privacy = () => {
  return (
    <Container>
      <Title>Privacy Policy</Title>
      
      <Section>
        <Text>Last updated: January 2024</Text>
        <Text>
          At Binventory, we take your privacy seriously. This Privacy Policy explains how we collect, 
          use, and protect your personal information.
        </Text>
      </Section>

      <Section>
        <Subtitle>1. Information We Collect</Subtitle>
        <Text>We collect the following types of information:</Text>
        <List>
          <li>Account information (name, email, password)</li>
          <li>Payment information (processed securely through Stripe)</li>
          <li>Inventory data (items, photos, locations)</li>
          <li>Usage data (how you interact with our service)</li>
        </List>
      </Section>

      <Section>
        <Subtitle>2. How We Use Your Information</Subtitle>
        <Text>We use your information to:</Text>
        <List>
          <li>Provide and improve our services</li>
          <li>Process payments and manage subscriptions</li>
          <li>Send important service updates</li>
          <li>Respond to your requests and support needs</li>
          <li>Prevent fraud and abuse</li>
        </List>
      </Section>

      <Section>
        <Subtitle>3. Data Security</Subtitle>
        <Text>
          We implement industry-standard security measures to protect your data. This includes 
          encryption, secure servers, and regular security audits.
        </Text>
      </Section>

      <Section>
        <Subtitle>4. Data Sharing</Subtitle>
        <Text>
          We never sell your personal information. We only share your data with trusted service 
          providers who help us operate our service (like Stripe for payment processing).
        </Text>
      </Section>

      <Section>
        <Subtitle>5. Your Rights</Subtitle>
        <Text>You have the right to:</Text>
        <List>
          <li>Access your personal information</li>
          <li>Correct inaccurate data</li>
          <li>Request deletion of your data</li>
          <li>Export your data</li>
          <li>Opt-out of marketing communications</li>
        </List>
      </Section>

      <Section>
        <Subtitle>6. Contact Information</Subtitle>
        <Text>
          For privacy-related questions or concerns, contact our Data Protection Officer:
        </Text>
        <Text>
          Email: privacy@binventory.com<br />
          Phone: (555) 123-4567<br />
          Address: 123 Inventory Lane, Suite 100, San Francisco, CA 94105
        </Text>
      </Section>
    </Container>
  );
};

export default Privacy; 